import React from 'react';
import PropTypes from 'prop-types';
import {
  Paper, FlatButton, TextField, AutoComplete, Dialog,
} from 'material-ui';
import { StyleSheet, css } from 'aphrodite';
import { connect } from 'react-redux';

import * as InquiryActions from '../../store/actions/InquiryActions';
import DateRange from '../DateRangeComponent';
import search from '../../rest';

@connect(state => ({ inquiry: state.Inquiry.get('inquiry').toJS() }))
export default class AddSegment extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    inquiry: PropTypes.shape().isRequired,
  }

  constructor(props) {
    super(props);

    this.state = {
      segmentAutocompleteData: [],
      id: '',
      vendor: '',
      startDate: '',
      endDate: '',
      notes: '',
      confirmNewVendor: false,
    };
  }

  onCancel = () => {
    this.props.dispatch(
      InquiryActions.updateField(['meta', 'addingSegment'], false));
  }

  onSave = () => {
    if (!this.state.id && this.state.vendor) {
      this.setState({ confirmNewVendor: true });
    } else {
      this.addVendor();
    }
  }

  cancelNewVendor = () => {
    this.setState({ confirmNewVendor: false });
  }

  confirmNewVendor = () => {
    this.setState({ confirmNewVendor: false });
    this.addVendor();
  }

  addVendor = () => {
    const { dispatch } = this.props;
    const { id, vendor, startDate, endDate, notes } = this.state;
    const { updateField, addSegment } = InquiryActions;

    dispatch(updateField(['meta', 'addingSegment'], false));
    dispatch(addSegment({ id, vendor, startDate, endDate, notes }));
  }

  handleUpdateSegmentAutocomplete = (value) => {
    search('auto/vendor', value).then((response) => {
      const { objects } = response;
      this.setState({
        vendor: value,
        segmentAutocompleteData: objects.map(object => ({
          text: object.name,
          value: object.relayId,
          name: object.name,
          score: object.score,
        })),
      });
    }).catch((response) => {
      console.log(response);
    });
  }

  vendorSelected = (selected, index) => {
    const { dispatch, inquiry: { tripDetails: { destination } } } = this.props;

    if (index !== -1) {
      const { value: id, name } = selected;

      this.setState({ id, name });
      if (!destination) {
        dispatch(
          InquiryActions.updateField(
            ['inquiry', 'tripDetails', 'destination'], name));
      }
    }
  }

  updateTextField = field => (e) => {
    const newState = { dirty: true };
    newState[field] = e.target.value;
    this.setState(newState);
  }

  updateDates = (e) => {
    const { startDate, endDate } = e;
    this.setState({ startDate, endDate });
  }

  render() {
    const {
      vendor, segmentAutocompleteData, startDate, endDate, notes,
      confirmNewVendor,
    } = this.state;

    const actions = [
      <FlatButton
        label='No'
        primary
        onTouchTap={this.cancelNewVendor}
      />,
      <FlatButton
        label='Yes'
        primary
        onTouchTap={this.confirmNewVendor}
      />,
    ];

    return (<div>
      <Paper className={css(styles.addBox)}>
        <AutoComplete
          style={styles.formFieldStyle}
          menuStyle={{ width: 500 }}
          listStyle={{ width: 500 }}
          floatingLabelText='Vendor'
          dataSource={segmentAutocompleteData}
          onUpdateInput={this.handleUpdateSegmentAutocomplete}
          onNewRequest={this.vendorSelected}
          filter={() => true}
          fullWidth
        />
        <DateRange
          startValue={startDate}
          endValue={endDate}
          startLabel='Start Date'
          endLabel='End Date'
          onChange={this.updateDates}
        />
        <TextField
          floatingLabelText='Notes'
          value={notes}
          onChange={this.updateTextField('notes')}
          fullWidth
        />
        <div className={css(styles.controls)}>
          <FlatButton label='Cancel' onTouchTap={this.onCancel} secondary />
          <FlatButton label='Submit' onTouchTap={this.onSave} primary />
        </div>
      </Paper>
      <Dialog
        title='Confirm New Vendor'
        actions={actions}
        modal
        open={confirmNewVendor}
      >
        <p>You did not select an existing vendor from our database. Are you sure
        that &ldquo;{vendor}&rdquo; is not one of the following?</p>
        <ul style={styles.alternativeList}>
          {segmentAutocompleteData.filter(({ score }) => score > 1).slice(
            0, 10).map(
            ({ text, value: id }) => <li key={id} style={styles.alternativeVendor}>
              <span>{text}</span>
              <FlatButton
                label='select'
                onTouchTap={this.selectAlternateVendor(id, text)}
              />
            </li>
          )}
        </ul>
      </Dialog>
    </div>);
  }
}

const styles = StyleSheet.create({
  addBox: {
    marginLeft: 15,
    flexGrow: 1,
    padding: '0 15px 15px 15px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 839,
    '@media (min-width: 970px)': {
      minWidth: 839,
    },
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
  },
  checkBox: {
    width: 256,
  },
});



// WEBPACK FOOTER //
// /src/components/Inquiry/AddSegment.js